import { render, staticRenderFns } from "./ImmowebCodeSearch.vue?vue&type=template&id=48d0fd5b&"
import script from "./ImmowebCodeSearch.vue?vue&type=script&lang=ts&"
export * from "./ImmowebCodeSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports